import { FlexColumnAlignJustifyCenter } from "@/components/Flex";
import Mountable from "@/components/styled/div/Mountable";
import { themeColors } from "@/utils/themeColors";
import { Node } from "@knowt/editor/pm/model";
import { Editor, NodeViewWrapper } from "@knowt/editor/react";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import { useCallback, useRef } from "react";

interface ImageBlockViewProps {
    editor: Editor;
    getPos: () => number;
    node: Node;
    updateAttributes: (attrs: Record<string, string>) => void;
    selected: boolean;
}

export const ImageBlockView = (props: ImageBlockViewProps) => {
    const { editor, getPos, node, updateAttributes, selected } = props;
    const imageWrapperRef = useRef<HTMLDivElement>(null);
    const { src, alt } = node.attrs;

    const wrapperStyle = {
        width: node.attrs.width,
        marginLeft: node.attrs.align === "left" ? "0" : "auto",
        marginRight: node.attrs.align === "right" ? "0" : "auto",
        ...(node.attrs.align === "center" && { marginLeft: "auto", marginRight: "auto" }),
    };

    const onClick = useCallback(() => {
        editor.commands.setNodeSelection(getPos());
    }, [getPos, editor.commands]);

    return (
        <NodeViewWrapper>
            <div style={wrapperStyle} data-testid="auto-id-e7a1d8a0-a64e-4932-97f4-a4d093387621">
                <div
                    contentEditable={false}
                    ref={imageWrapperRef}
                    data-testid="auto-id-d60a0467-59bd-4807-a219-9ef9de86db84">
                    {/* biome-ignore lint: noInvalidUseBeforeDeclaration */}
                    <img
                        style={{ display: "block" }}
                        src={src}
                        alt={alt}
                        onClick={onClick}
                        data-testid="auto-id-eefd6c10-76a2-4c00-8b22-df36c46ba962"
                    />
                </div>
            </div>
            <Mountable mount={editor.isEditable ? selected || alt : alt}>
                <FlexColumnAlignJustifyCenter style={{ margin: "0 auto", width: "100%" }}>
                    <TextareaAutosize
                        disabled={!editor.isEditable}
                        style={{
                            backgroundColor: "transparent",
                            border: "none",
                            outline: "none",
                            marginTop: "0.5rem",
                            fontFamily: "inherit",
                            resize: "none",
                            opacity: !alt ? "0.55" : "0.7",
                            textAlign: "center",
                            fontSize: "14px",
                            color: themeColors.neutralBlack,
                        }}
                        maxRows={4}
                        placeholder="add caption here"
                        value={alt}
                        onChange={e => updateAttributes({ alt: e.target.value })}
                    />
                </FlexColumnAlignJustifyCenter>
            </Mountable>
        </NodeViewWrapper>
    );
};

export default ImageBlockView;
